const INTRISING_EMAIL_DOMAIN = '@intrising.com.tw'

const LANTECH_QA_EMAILS = [
  'lewis@lantechcom.tw',
  'jacky@lantechcom.tw'
]

const PT_RELEASE_NOTE_EXTRA_EDITOR_EMAILS = [
  'greg@lantechcom.tw'
]

function normalizeEmail (email) {
  return typeof email === 'string' ? email.trim().toLowerCase() : ''
}

export function isIntrisingEmail (email) {
  const e = normalizeEmail(email)
  return e !== '' && e.endsWith(INTRISING_EMAIL_DOMAIN)
}

export function isLantechQAEmail (email) {
  const e = normalizeEmail(email)
  return e !== '' && LANTECH_QA_EMAILS.includes(e)
}

export function canSeeMtMenu (user = {}) {
  const role = user && user.role
  const email = user && user.email
  return role === 'admin' || isIntrisingEmail(email) || isLantechQAEmail(email)
}

export function canEditPtReleaseNote (user = {}) {
  const role = user && user.role
  const email = user && user.email
  const e = normalizeEmail(email)
  return role === 'admin' ||
    isLantechQAEmail(email) ||
    PT_RELEASE_NOTE_EXTRA_EDITOR_EMAILS.includes(e)
}




// WEBPACK FOOTER //
// ./src/utils/permissions.js